import React from 'react';

/**
 * Slim attribution footer. Rendered at the bottom of the main scroll
 * region (not fixed), so it sits below whatever content is on the page
 * without overlapping, floating menus, modals, or mobile drawers.
 *
 * Variants:
 *   - `variant="app"` — used inside the authenticated ApplicationShell.
 *     Uses muted colours and small spacing so it blends with any page.
 *   - `variant="auth"` — used on the login/register screens where the
 *     background is often coloured; uses lighter text.
 */
const Footer = ({ variant = 'app' }) => {
    const year = new Date().getFullYear();
    const tone = variant === 'auth'
        ? 'text-white/70 hover:text-white'
        : 'text-gray-500 hover:text-gray-700';
    const wrapper = variant === 'auth'
        ? 'w-full px-4 py-4 text-center text-xs'
        : 'mt-8 border-t border-gray-100 px-4 py-3 text-center text-[11px] sm:text-xs';

    return (
        <footer className={wrapper} role="contentinfo">
            <p className={tone}>
                &copy; {year} BookMyAcre CRM. Developed by{' '}
                <a
                    href="https://omazel.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`font-semibold underline-offset-2 hover:underline ${variant === 'auth' ? 'text-white' : 'text-indigo-600 hover:text-indigo-700'}`}
                >
                    Omazel LLP
                </a>
                .
            </p>
        </footer>
    );
};

export default Footer;
